export default "__VITE_ASSET__BWvzJCN9__"